import ProgressCircle from './ProgressCircle';
import ProgressLine from './ProgressLine';
export default {
  Line: ProgressLine,
  Circle: ProgressCircle
};